export default function useIsTouch() {
  return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
}